import * as React from 'react';
import { bindLandCheck } from '../../lib/support';
import styles from './index.module.sass'
import isDev from './../../lib/isDev'
import mobileScreen from '../../assets/mobile/mobileScreen.png'

export interface LandscapeProps {
  isLandscape: Boolean,
  setLand: Function
}

const Landscape: React.FunctionComponent<LandscapeProps> = ({ setLand, isLandscape }) => {
  React.useEffect(() => {
    bindLandCheck(setLand)
  }, [setLand])
  
  return (
      isLandscape || isDev?
        null
        :
        <>
          <div className={styles.bg}>
            
          </div>
          <div className={styles.blur}>

          </div>
          <div className={`${styles.root}`}>
            <div className={styles.logo}></div>
            <div className={styles.wrapper}>
              <div className={styles.outerCircle}>
                <div className={styles.innerCircle}>
                  <img src={mobileScreen} alt='sad'/>
                  <div className={styles.text}>
                    To view this experience please rotate your phone
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
  );
};

export default Landscape;
